import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { useClientMounted } from '../../hooks/useClientMounted';
import { publicPath } from '../../utils/canonicalUrl';
import VcLogo from './VcLogo';
import './Header.css';

const NAV = [
  { to: publicPath('/ricerca'), label: 'Visite ed esami', end: false },
  { to: publicPath('/medici'), label: 'Medici', end: false },
  { to: publicPath('/strutture'), label: 'Strutture', end: false },
  { to: publicPath('/fondi-sanitari'), label: 'Fondi e assicurazioni', end: false },
];

const Header = () => {
  const { isAuthenticated } = useAuth();
  const clientMounted = useClientMounted();
  const [menuOpen, setMenuOpen] = useState(false);
  const showLoggedInNav = clientMounted && isAuthenticated();

  const closeMenu = () => setMenuOpen(false);

  useEffect(() => {
    if (!menuOpen) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') closeMenu();
    };
    window.addEventListener('keydown', onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = prev;
    };
  }, [menuOpen]);

  return (
    <header className="vc-header">
      <div className="vc-container vc-header-inner">
        <Link to="/" className="vc-logo" onClick={closeMenu} aria-label="Virtual Clinic - Home">
          <VcLogo height={36} />
        </Link>

        <button
          type="button"
          className="vc-nav-toggle"
          aria-expanded={menuOpen}
          aria-controls="vc-main-nav"
          aria-label={menuOpen ? 'Chiudi menu' : 'Apri menu'}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          {menuOpen ? (
            <span className="vc-nav-toggle-x" aria-hidden>×</span>
          ) : (
            <>
              <span className="vc-nav-toggle-bar" />
              <span className="vc-nav-toggle-bar" />
              <span className="vc-nav-toggle-bar" />
            </>
          )}
        </button>

        {menuOpen && (
          <button
            type="button"
            className="vc-nav-backdrop"
            aria-label="Chiudi menu"
            onClick={closeMenu}
          />
        )}

        <nav id="vc-main-nav" className={`vc-nav ${menuOpen ? 'vc-nav-open' : ''}`} aria-label="Principale">
          {NAV.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              className={({ isActive }) => `vc-nav-link${isActive ? ' vc-nav-link--active' : ''}`}
              onClick={closeMenu}
            >
              {item.label}
            </NavLink>
          ))}
          <div className="vc-nav-auth">
            <Link
              to={publicPath('/per-le-strutture')}
              className="vc-nav-link vc-nav-link--muted"
              onClick={closeMenu}
            >
              Per le strutture
            </Link>
            {showLoggedInNav ? (
              <Link to="/app" className="vc-btn vc-btn-ink" onClick={closeMenu}>Area riservata</Link>
            ) : (
              <Link to="/login" className="vc-btn vc-btn-ink" onClick={closeMenu}>Accedi</Link>
            )}
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
